@if (skogsvardsAtgard && (kontrakt$ | async); as kontrakt) {
  <rask-toggle-panel #togglePanel
    [ngClass]="{'highlight' : highlight}">
    <ng-container customHeader #customHeader>
      <rask-skogsvard-header [index]="index + 1"></rask-skogsvard-header>
    </ng-container>
    <ng-container>
      <rask-virkeskop-validation-message
        entityType="skogsvardsatgard"
        [entityGuid]="skogsvardEntity.guid">
      </rask-virkeskop-validation-message>
      <rask-tabs class="parent" layout="parent" [wrap]="true" [useRoute]="false">
        <rask-tab #detaljer label="Detaljer" [icon]="getIcon('skogsvardsatgarddetaljer')">
          <rask-skogsvard-detaljer></rask-skogsvard-detaljer>
        </rask-tab>
        @if (showTradskikt()) {
          <rask-tab #tradskikt label="Trädskikt">
            <rask-skogsvard-tradskikt></rask-skogsvard-tradskikt>
          </rask-tab>
        }
        @if (showTradslag()) {
          <rask-tab label="Trädslag">
            <rask-skogsvard-tradslag-plantor></rask-skogsvard-tradslag-plantor>
          </rask-tab>
        }
        @if (showForyngring()) {
          <rask-tab #foryngring label="Föryngring" [icon]="getIcon('skogsvardsatgardforyngring')">
            <rask-skogsvard-foryngring></rask-skogsvard-foryngring>
          </rask-tab>
        }
        @if (showMarkBehandling()) {
          <rask-tab [label]="namnForMarkbehandlingFlik()">
            <rask-skogsvard-markbehandling-standort></rask-skogsvard-markbehandling-standort>
          </rask-tab>
        }
        <rask-tab #ovrigt label="Övrigt" [icon]="getIcon('skogsvardsatgardovrigt')">
          <rask-skogsvard-ovrigt></rask-skogsvard-ovrigt>
        </rask-tab>
      </rask-tabs>
    </ng-container>
  </rask-toggle-panel>
} @else {
  <div class="atgard-loading placeholder-glow py-2 pr-2">
    <div class="col-7">
      <span class="placeholder col-2"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-3"></span>
      <span class="placeholder col-5"></span>
      <span class="placeholder col-2"></span>
    </div>
  </div>
}
